import { z } from 'zod'
import { oc } from '@orpc/contract'
import { billingCaseDtoSchema } from './update-case.contract'

/**
 * The routes a biller may pick by hand in the Routing column. `none` is deliberately
 * absent: it is the sweep's "not decided yet", and a hand-picked route is final for the
 * sweep (it only ever routes a `none` case).
 */
export const BILLER_SUBMISSION_ROUTE_VALUES = ['manual', 'bridge', 'stedi'] as const

export type BillerSubmissionRouteValue = (typeof BILLER_SUBMISSION_ROUTE_VALUES)[number]

/**
 * The biller's route override. Refused once an insurance payment is recorded on the case.
 * A case that already counts as submitted (claim_submitted_at, a mid-chain external claim
 * id, or a hand-marked Submitted status) is re-routed only with `discardSubmission: true`
 * — the UI asks first — which clears the submission markers and drops a `billed`/`failed`
 * status back to `ready-to-bill`; without the flag the request is a 400.
 */
export const billingV2SetRoute = oc
  .route({ method: 'POST', path: '/v2/billing/case/set-route' })
  .input(
    z.object({
      encounterId: z.string().min(1),
      submissionRoute: z.enum(BILLER_SUBMISSION_ROUTE_VALUES),
      discardSubmission: z.boolean().optional(),
    }),
  )
  .output(z.object({ case: billingCaseDtoSchema }))
